































import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import TimeLineItemText from "@/components/utility/TimeLineItemText.vue";
import TimelineCard from "@/components/utility/TimelineItem.vue";
import { Clearance, IClearance } from "@/models/clearance.entity";

@Component({
  components: { TimeLineItemText, TimelineCard },
  filters: { simpleDoubleDigitDate }
})
export default class ClearanceResponseCardHistory extends mixins(PermissionMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly formatCurrency = formatCurrency;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = Clearance.statusIconMap;

  readonly statusColorMap = Clearance.statusColorMap;

  @Prop()
  value!: IClearance;
}
